import * as React from "react";
import * as ReactDOM from "react-dom/client";
import {
  createHashRouter,
  Navigate,
  Outlet,
  RouterProvider,
  useLocation,
} from "react-router-dom";
import { useEffect } from "react";
import "./index.css";
import { About } from "pages/About";
import { Header } from "components/Header";
import { Home } from "pages/Home";
import { Footer } from "components/Footer";
import { DemoReel, videosOtherWorks, videosPrimary } from "pages/DemoReel";
import { ThreeDS } from "pages/ThreeDS";

const router = createHashRouter([
  {
    path: "/",
    element: <AppWrapper />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/about",
        element: <About />,
      },
      {
        path: "/3dexcite",
        element: <ThreeDS />,
      },
      {
        path: "/3ds",
        element: <Navigate to="/3dexcite" replace />,
      },
      {
        path: "/demo-reel",
        element: <DemoReel videos={videosPrimary} />,
      },
      {
        path: "/other-works",
        element: <DemoReel videos={videosOtherWorks} />,
      },
    ],
  },
]);

//@ts-ignore
ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);

function AppWrapper() {
  const location = useLocation();

  useEffect(() => {
    if (!location.search.includes("video=")) {
      window.scrollTo({ top: 0, behavior: "instant" as ScrollBehavior });
    }
  }, [location.pathname, location.search]);

  return (
    <div className="dark flex min-h-screen flex-col">
      <a
        href="#main-content"
        className="sr-only z-[100] bg-ember px-4 py-3 text-white focus:not-sr-only focus:fixed focus:left-4 focus:top-4"
      >
        Skip to content
      </a>
      <Header />
      <main id="main-content" className="flex flex-1 flex-col">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
